import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query'
import { ENV, dotenv } from 'config/dotenv.config'

export const rtkBaseQuery = fetchBaseQuery({
    baseUrl: dotenv.get(ENV.API_URL),
})

export const REFETCH_INTERVAL_S = 30
export const REFETCH_INTERVAL_MS = REFETCH_INTERVAL_S * 1000
